<div class="multi-select-container">
    <!-- Display Span Showing Selected Options -->
    <span (click)="toggleDropdown(true)" class="selected-options" style="width: 100%" >
      {{ selectedOptionsText | slice:0:30}} <span *ngIf="selectedOptionsText && selectedOptionsText.length > 30">...</span>
    </span>

    <!-- Searchable Input Field -->
     <div  *ngIf="dropdownOpen" class="dropdown">
        <div class="search-box ">
            <input
              type="text"
              placeholder="Search..."
              [(ngModel)]="searchTerm"
              (input)="onSearchChange()"
            />
          </div>

          <!-- Dropdown with options -->
          <div (click)="$event.stopPropagation()">
            <div class="option" *ngIf="isMulti">
              <label class="container">
                Select All
                <input
                  type="checkbox"
                  [checked]="selectAllChecked"
                  (change)="toggleSelectAll($event)"
                  [disabled]="!isMulti"
                />
                <span class="checkmark" [ngClass]="{'raduis-border': !isMulti}"></span>
              </label>
            </div>

            <!-- List of Filtered Options -->
            <div *ngFor="let option of filteredOptions" class="option">
              <label class="container">
                {{ option.name }}
                <input
                  type="checkbox"
                  [checked]="isOptionSelected(option.id)"
                  (change)="toggleOption(option.id, $event)"
                />
                <span class="checkmark" [ngClass]="{'raduis-border': !isMulti}"></span>
              </label>
            </div>
          </div>
     </div>

  </div>
